<ion-row class="pin-container ion-align-items-center ion-justify-content-center">
  <div class="pin-form">
    <ion-icon [name]="pin.length > 0 ? 'radio-button-on' : 'radio-button-off'" />
    <ion-icon [name]="pin.length > 1 ? 'radio-button-on' : 'radio-button-off'" />
    <ion-icon [name]="pin.length > 2 ? 'radio-button-on' : 'radio-button-off'" />
    <ion-icon [name]="pin.length > 3 ? 'radio-button-on' : 'radio-button-off'" />
    <ion-icon [name]="pin.length > 4 ? 'radio-button-on' : 'radio-button-off'" />
  </div>
</ion-row>
